<template>
  <div>
    <add-member v-if="currentFlowStep === onboardingFlowSteps.addMember"
                  :next="() => setCurrentFlowStep(onboardingFlowSteps.preferences)"/>
    <preferences v-else-if="currentFlowStep === onboardingFlowSteps.preferences"
                       :next="goToAddCredentials"/>
  </div>
</template>

<script>

import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import Preferences from './steps/Preferences.vue';
import AddMember from './steps/AddMember.vue';
import router from '../../../../router';

export default {
  name: 'OnboardingFlow',
  components: {
    AddMember,
    Preferences,
  },

  async created() {
    this.startLoading(this.$options.name);
    await this.fetchCredentials();
    this.doneLoading(this.$options.name);
    if (this.hasCredentials) {
      this.goToAddCredentials();
    } else {
      this.setCurrentFlowStep(this.onboardingFlowSteps.addMember);
    }
  },
  computed: {
    ...mapState('onboarding', ['currentFlowStep']),
    ...mapGetters('onboarding', ['onboardingFlowSteps']),
    ...mapGetters('credentials', ['hasCredentials']),
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
    ...mapActions('credentials', ['fetchCredentials']),
    ...mapMutations('onboarding', ['setCurrentFlowStep']),
    goToAddCredentials() {
      const { reminder } = this.$route.query;
      router.push({ path: '/onboard/add-credentials', query: { reminder } });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard/OnboardingFlow.vue